import {makeAutoObservable} from 'mobx';

class HistoryStore {

    history: any;

    constructor() {
        makeAutoObservable(this);
    }

    navigate(url: string) {
        this.history.push(url);
    }
}

const historyStore = new HistoryStore();

export default historyStore;